import React from 'react';

const MetricsFilterInput = React.createClass({
  render() {
    return (
      <input type="text" className="metrics-filter input-lg form-control"
             style={{ width: '100%' }} placeholder="Type a metric name to filter..." {...this.props} />
    );
  },
});

export default MetricsFilterInput;



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/graylog-project-cli-release/.repos/graylog2-server/graylog2-web-interface/src/components/metrics/MetricsFilterInput.jsx